






















import Vue from 'vue';
import { upload, uploadPublicUrlImage } from '@/web/services/upload';
import { makeid } from '@/core/utils/utils';
import { getCanvaButtonApi } from '@/web/services/canva';

export default Vue.extend({
  name: 'HMCanvaUpload',
  props: {
    value: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isUploading: false,
      selectedImageUrl: '',
      progress: 0,
    };
  },
  methods: {
    openCanva() {
      getCanvaButtonApi().createDesign({
        design: {
          type: 'Poster',
        },
        onDesignOpen: ({ designId }) => {
          // Triggered when editor finishes loading and opens a new design.
          // You can save designId for future use.
          console.log('Canva designer opened');
        },
        onDesignPublish: ({ exportUrl, designId }) => {
          // Triggered when design is published to an image.
          // Save the image to your server as the exportUrl will expire shortly.
          console.log('Canva design published. Image url=', exportUrl);
          this.imageCreated(exportUrl);
        },
        onDesignClose: () => {
          // Triggered when editor is closed.
          console.log('Canva designer closed');
        },
      });
    },
    imageCreated(imageUrl) {
      console.log('imageCreated=', imageUrl);
      if (!imageUrl) return;
      this.selectedImageUrl = imageUrl;
    },
    async urlToFile(imageUrl) {
      const response = await fetch(imageUrl);
      // here image is url/location of image
      const blob = await response.blob();
      // TODO check blob type to see if we get JPG or PNG
      let filename = `canva-${makeid(12)}`;
      try {
        filename = imageUrl.match(/.*\/([^?]+)/)[1];
      } catch (error) {
        console.log('Failed to parse filename, using random one');
      }
      const file = new File([blob], filename, { type: blob.type });
      console.log(file);
      return file;
    },
    async upload() {
      this.isUploading = true;
      const urlFile = await this.urlToFile(this.selectedImageUrl);
      const file = await upload(
        urlFile,
        progress => (this.progress = progress)
      );
      this.updateFile(file);
      this.isUploading = false;
      return file;
    },
    updateFile(file) {
      this.$emit('input', file);
    },
  },
});
